module.exports = __webpack_public_path__ + "img/ring_g_o_null_0@3x.4cec2495.png";